<template>
  <div>
    <div>
      <div class="d-block d-md-flex align-items-center">
        <h3 class="title-content m-0">Meus Veículos</h3>
        <v-btn class="btn-confirm ml-auto" v-if="hasPlates && showAutomaticActivation ==='true'"
               @click="checkVehiclesAutomaticAll(plates)">
          Ativação automática em todos os meus veículos
        </v-btn>
        <v-btn class="btn-confirm ml-auto" @click="dialog.new_vehicle = true">Novo Veículo</v-btn>
      </div>
    </div>
      <div class="vehicle-card"
           v-for="plate in plates"
           :key="plate.id"
      >
        <v-card class="mb-2">
          <div class="col-12">
            <div class="box d-block d-md-flex justify-space-around align-items-center">
              <div class="flex-grow-1">
                <div class="px-1">
                  <h6>
                    <i class="fas fa-car"></i>
                    {{
                        idx(plate.vehicle, _ => _.vehicle_maker_model.name) || 'Montadora não encontrada'
                    }}
                  </h6>
                  <h2>{{ plate.plate }}</h2>
                </div>
              </div>
              <div class="box-details flex-grow-1">
                <div class="row px-1">
                  <span>Status</span>
                  <span class="ml-auto">
                    {{plate.status_enum | capitalize }}
                  </span>
                </div>
                <div class="row px-1">
                  <span>Irregularidades</span>
                  <span class="ml-auto">
                    {{ plate.pending_notifications }}
                  </span>
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="d-block">
                  <template v-if="plate.wallet !== null && user_id === plate.wallet.user_id">
                    <button class="d-block mb-3 m-0 ml-md-auto"
                            :class="{'btn-red': advancedWalletOptions !== 'false','btn-blue': advancedWalletOptions !== 'true'}"
                            @click="plate_selected = plate,dialog.removeVehicle = true">
                      <i class="fas fa-times mr-2"/>
                      Remover Veículo
                    </button>
                    <button class="d-block mb-3 m-0 ml-md-auto text-no-wrap btn-automation-activation" v-if="showAutomaticActivation === 'true'"
                            @click='singleAutomationActivation(plate)'>
                      <i class="fas fa-check mr-2"/>
                      {{
                        plate.vehicle.automatic_activation ? 'Desativar Ativação Autom.' : `Ativar Ativação Autom.`
                      }}
                    </button>
                  </template>
                  <div v-else style="width: 250px;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    <v-snackbar
        v-model="message_success_activated"
        :color="'success'"
        :multi-line="true"
        :right="true"
        :timeout="2000"
        :top="true"
        class="snackbar-success"
    >
      <span><i class="fas fa-check mr-2"/>Ativação Automática habilitada com sucesso!</span>
    </v-snackbar>

    <v-snackbar
        v-model="message_success_disabled"
        :color="'success'"
        :multi-line="true"
        :right="true"
        :timeout="2000"
        :top="true"
        class="snackbar-success"
    >
      <span><i class="fas fa-check mr-2"/>Ativação Automática desabilitada com sucesso!</span>
    </v-snackbar>

    <v-snackbar
        v-model="message_no_vehicles"
        :color="'warning'"
        :multi-line="true"
        :right="true"
        :timeout="2000"
        :top="true"
        class="snackbar-warning"
    >
      <span><i class="fas fa-check mr-2"/>Não há Carros Para Ativar a Ativação Automática!</span>
    </v-snackbar>

    <v-snackbar
        v-model="message_fail"
        :color="'red'"
        :multi-line="true"
        :right="true"
        :timeout="2000"
        :top="true"
        class="snackbar-danger"
    >
      <span><i class="fas fa-check mr-2"/>Houve um erro. Tente novamente mais tarde!</span>
    </v-snackbar>

    <v-dialog v-if="dialog.new_vehicle" v-model="dialog.new_vehicle" persistent max-width="600px">
      <new-vehicle @close="dialog.new_vehicle = false,init()"/>
    </v-dialog>
    <v-dialog v-else-if="dialog.removeVehicle" v-model="dialog.removeVehicle" persistent max-width="600px">
      <remove-vehicle :vehicle="plate_selected" @close="dialog.removeVehicle = false,init()"/>
    </v-dialog>
    <v-dialog v-else-if="dialog.automatic_activation" v-model="dialog.automatic_activation" max-width="600px">
      <automatic-activation :vehicle="plate_selected"
                            @close="dialog.automatic_activation = false,init()"
                            @success="dialog.automatic_activation = false,message_success_activated=true,init()"
                            @error="dialog.automatic_activation = false,message_fail=true,init()"/>
    </v-dialog>
    <div class="message-data" v-show="plates.length === 0 && loading === false">
      <i class="far fa-bell"/>
      <span>Você não possui nenhum veículo cadastrado.</span>
    </div>
  </div>

</template>

<script>
import NewVehicle from '../components/NewVehicle';
import RemoveVehicle from '../components/RemoveVehicle';
import AutomaticActivation from "../components/AutomaticActivation";
import axios from 'axios';
import idx from "idx";

export default {
  name: "Vehicle",
  components: {AutomaticActivation, NewVehicle, RemoveVehicle},
  data: function () {
    return {
      plates: [],
      plate_selected: null,
      dialog: {
        new_vehicle: false,
        removeVehicle: false,
        automatic_activation: false,
        conflict: false
      },
      loading: false,
      message_success_activated: false,
      message_success_disabled: false,
      message_fail: false,
      message_no_vehicles: false,
      conflict: [],
    }
  },
  mounted: function () {
    this.init();
  },
  methods: {
    idx,
    init: function () {
      this.loading = true;
      axios.get('/api/users/driver/me/plate').then(res => {
        this.plates  = res.data.data;
        this.loading = false;
      });
    },
    singleAutomationActivation: function (targetPlate) {
      targetPlate.vehicle.automatic_activation ? (this.disableAutomaticActivation(targetPlate)) : (this.plate_selected = [targetPlate], this.dialog.automatic_activation = true);
    },
    disableAutomaticActivation: function (targetVehicle) {
      axios.put(`/api/vehicle/${targetVehicle.id}/automatic_activation`).then(res => {
        if (res) {
          this.message_success_disabled = true;
          this.init();
        }
      }).catch(err => {
        if (err) {
          this.message_fail = true;
          this.init();
        }
      });
    },
    checkVehiclesAutomaticAll: function (vehicles) {
      const user_id = this.user_id;
      vehicles = vehicles.filter(function (vehicle) {
        return vehicle.wallet.user_id === user_id && !vehicle.automatic_activation;
      });
      if (vehicles.length === 0) {
        this.message_no_vehicles = true;
      } else {
        this.plate_selected              = vehicles;
        this.dialog.automatic_activation = true;
      }
    }
  },
  computed: {
    advancedWalletOptions: function () {
      return process.env.VUE_APP_ADVANCED_WALLET_OPTIONS;
    },
    user_id: function () {
      return JSON.parse(localStorage.getItem('user')).id;
    },
    showWallets() {
      return process.env.VUE_APP_SHOW_WALLETS;
    },
    hasPlates() {
      const user_id = this.user_id;
      return this.plates && (this.plates.filter(function (plate) {
        return plate.wallet.user_id === user_id;
      }).length) > 0;
    },
    showAutomaticActivation() {
      return process.env.VUE_APP_SHOW_AUTOMATIC_ACTIVATION;
    }

  }
}
</script>

<style scoped>
.box {
  padding: 10px;
}

h6 {
  font-size: 14px;
  color: #595959;
  font-family: Roboto-Light;
  margin: 0;
}

h2 {
  font-size: 28px;
  font-family: Roboto-Black;
  color: #595959;
  margin: 0 0 3px 0;
}

.box-details {
  border-left: 1px dashed #e2e2e2;
  border-right: 1px dashed #e2e2e2;
  padding: 20px;
  font-size: 14px;
  font-family: Roboto-Bold;
  color: #595959;
  display: block;
  width: 300px;

}

.btn-blue {
  text-transform: capitalize;
  background: #000;
  color: #ffffff;
  font-family: Roboto-Black;
  width: 250px;
  height: 43px;
  border-radius: 4px;
  padding: 8px 15px;
  border: 3px solid #000;
}

.btn-blue:hover {
  background: transparent;
  color: #000;
}

.btn-red {
  text-transform: capitalize;
  background: #e72c1f;
  color: #ffffff;
  font-family: Roboto-Black;
  width: 250px;
  height: 43px;
  border-radius: 4px;
  padding: 8px 15px;
  border: 3px solid #e72c1f;
}

.btn-red:hover {
  background: transparent;
  color: #e72c1f;
}

.btn-automation-activation {
  text-transform: capitalize;
  background: #85850a;
  color: #ffffff;
  font-family: Roboto-Black;
  width: 250px;
  height: 43px;
  border-radius: 4px;
  padding: 8px 15px;
  border: 3px solid #85850a;
}

.btn-automation-activation:hover {
  background: transparent;
  color: #85850a;
}

@media only screen and (max-width: 957px) {
  .vehicle-card {
    text-align: center;
  }

  .box-details {
    border: 0;
    margin: 20px 0;
    width: 100%;
  }

  .btn-red, .btn-blue, .btn-automation-activation {
    width: 100%;
    margin: 0;
  }

  .btn-confirm {
    width: 100%;
  }
}

</style>
